var promo = $("[data-country-filter]");
var promoForFiltered = $("[data-country-filter-show]");
var hideCountries = $("[data-hide-banner]").data("hide-banner");
//var filterCountry = $('[data-simple-country-filter]').data('simple-country-filter');
var filterCountry = Shopify.country;
localStorage.setItem("country_code", Shopify.country);
console.log(filterCountry, "Country to Filter");

// console.log(hideCountries);

function checkIP(callback) {
	$.ajax({
		url: "https://ipapi.co/json?key=3uW3AKMIimqYv5ijbyyCKzIU8RkmSQTtsqhuTINwMMwYsEIx7w",
		dataType: "json",
		success: function (val) {
			var region = val.country_code;
			console.log(region, "success region");
			localStorage.setItem("country_code", val.country_code);
			callback(val.country_code);
		},
		error: function (returnval) {
			promo.show();
			console.log(returnval, "Error");
		},
	});
}

function ipCallback(region) {
	// console.log(region);

	if (filterCountry == region) {
		$("[data-simple-country-filter]").show();
		console.log("IP CHECK show filtered item");
	} else {
		console.log("IP CHECK keep item hidden");
	}

	if (!(hideCountries.indexOf(region) === -1)) {
		console.log("hide region");
		promoForFiltered.show();
	} else {
		console.log("show region");
		promo.show();
	}
}
$(document).ready(function () {
	if (localStorage.getItem("country_code") === null) {
		//  console.log('we need to get the country');
		checkIP(ipCallback);
	} else {
		var countryCode = localStorage.getItem("country_code");
		console.log(countryCode, "Local Storage Country");
		if (filterCountry == countryCode) {
			$("[data-simple-country-filter]").show();
			console.log("show filtered item");
		} else {
			console.log("keep item hidden");
		}

		console.log("LOCAL STORAGE", localStorage.getItem("country_code"));
		if (!(hideCountries.indexOf(localStorage.getItem("country_code")) === -1)) {
			console.log("hide region");
			promoForFiltered.show();
		} else {
			console.log("show region");
			promo.show();
		}
	}
}); // END DOC READY

/**
 $('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});
**/
